<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M2.09851 19.4166C2.64018 14.5416 4.80684 10.75 9.68184 8.58331"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.43183 16.1667C13.168 16.1667 17.8068 12.6047 18.3485 3.16667V1H14C4.25 1 1.01517 5.33333 1 10.75C1 11.8333 1 14 3.16667 16.1667H6.43183Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
